$.noConflict();
jQuery(document).ready(function($){
  $('.featured-collection__slider .product-grid').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_306_1790)"><g filter="url(#filter0_d_306_1790)"><path d="M21 33C27.6274 33 33 27.6274 33 21C33 14.3726 27.6274 9 21 9C14.3726 9 9 14.3726 9 21C9 27.6274 14.3726 33 21 33Z" fill="white"/></g><path d="M24.7899 21.0281C25.07 20.7365 25.07 20.2635 24.7899 19.9719L20.2246 15.2188C19.9445 14.9271 19.4903 14.9271 19.2101 15.2188C18.93 15.5104 18.93 15.9833 19.2101 16.275L23.2682 20.5L19.2101 24.725C18.93 25.0167 18.93 25.4896 19.2101 25.7812C19.4903 26.0729 19.9445 26.0729 20.2246 25.7812L24.7899 21.0281ZM23.8044 21.2469H24.2826V19.7531H23.8044V21.2469Z" fill="#BEBEBE"/></g><defs><filter id="filter0_d_306_1790" x="5" y="5" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="4" dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_306_1790"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_306_1790" result="shape"/></filter><clipPath id="clip0_306_1790"><rect width="42" height="42" fill="white"/></clipPath></defs></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_306_1790)"><g filter="url(#filter0_d_306_1790)"><path d="M21 33C27.6274 33 33 27.6274 33 21C33 14.3726 27.6274 9 21 9C14.3726 9 9 14.3726 9 21C9 27.6274 14.3726 33 21 33Z" fill="white"/></g><path d="M24.7899 21.0281C25.07 20.7365 25.07 20.2635 24.7899 19.9719L20.2246 15.2188C19.9445 14.9271 19.4903 14.9271 19.2101 15.2188C18.93 15.5104 18.93 15.9833 19.2101 16.275L23.2682 20.5L19.2101 24.725C18.93 25.0167 18.93 25.4896 19.2101 25.7812C19.4903 26.0729 19.9445 26.0729 20.2246 25.7812L24.7899 21.0281ZM23.8044 21.2469H24.2826V19.7531H23.8044V21.2469Z" fill="#BEBEBE"/></g><defs><filter id="filter0_d_306_1790" x="5" y="5" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="4" dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_306_1790"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_306_1790" result="shape"/></filter><clipPath id="clip0_306_1790"><rect width="42" height="42" fill="white"/></clipPath></defs></svg></div>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          infinite: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.instafeed__wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_306_1790)"><g filter="url(#filter0_d_306_1790)"><path d="M21 33C27.6274 33 33 27.6274 33 21C33 14.3726 27.6274 9 21 9C14.3726 9 9 14.3726 9 21C9 27.6274 14.3726 33 21 33Z" fill="white"/></g><path d="M24.7899 21.0281C25.07 20.7365 25.07 20.2635 24.7899 19.9719L20.2246 15.2188C19.9445 14.9271 19.4903 14.9271 19.2101 15.2188C18.93 15.5104 18.93 15.9833 19.2101 16.275L23.2682 20.5L19.2101 24.725C18.93 25.0167 18.93 25.4896 19.2101 25.7812C19.4903 26.0729 19.9445 26.0729 20.2246 25.7812L24.7899 21.0281ZM23.8044 21.2469H24.2826V19.7531H23.8044V21.2469Z" fill="#BEBEBE"/></g><defs><filter id="filter0_d_306_1790" x="5" y="5" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="4" dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_306_1790"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_306_1790" result="shape"/></filter><clipPath id="clip0_306_1790"><rect width="42" height="42" fill="white"/></clipPath></defs></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_306_1790)"><g filter="url(#filter0_d_306_1790)"><path d="M21 33C27.6274 33 33 27.6274 33 21C33 14.3726 27.6274 9 21 9C14.3726 9 9 14.3726 9 21C9 27.6274 14.3726 33 21 33Z" fill="white"/></g><path d="M24.7899 21.0281C25.07 20.7365 25.07 20.2635 24.7899 19.9719L20.2246 15.2188C19.9445 14.9271 19.4903 14.9271 19.2101 15.2188C18.93 15.5104 18.93 15.9833 19.2101 16.275L23.2682 20.5L19.2101 24.725C18.93 25.0167 18.93 25.4896 19.2101 25.7812C19.4903 26.0729 19.9445 26.0729 20.2246 25.7812L24.7899 21.0281ZM23.8044 21.2469H24.2826V19.7531H23.8044V21.2469Z" fill="#BEBEBE"/></g><defs><filter id="filter0_d_306_1790" x="5" y="5" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="4" dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_306_1790"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_306_1790" result="shape"/></filter><clipPath id="clip0_306_1790"><rect width="42" height="42" fill="white"/></clipPath></defs></svg></div>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".text-with-icons__slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".product__media-slider").slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '30px',
        slidesToShow: 1,
        slidesToScroll: 1
      });

  if($(window).width() < 750){
    setTimeout(function(){
      $(".logo-list").show();
      $(".logo-list__wrapper").slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }, 100);

    $(".product-grid__images:not(.product-grid__single-image)").slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '30px',
        slidesToShow: 1,
        slidesToScroll: 1
      });
  }

  $(".cart-drawer__product-related").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $('.image-with-text__video-play').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

        callbacks: {
          open: function() {
            $(".image-with-text__video video").trigger("play");
            $('body').css('overflow', 'hidden');
          },
          close: function() {
            $(".image-with-text__video video").trigger("pause");
            $('body').css('overflow', '');
          }
        }
	});

  $(".card__atc").click(function(){
    $(this).parents(".card-wrapper").find(".quick-add__submit").trigger("click");
  });

  $(".back-to-top span").click(function(){
    $("html").animate({ scrollTop: 0 }, "slow");
  });

  $(".faq__accordion-title").click(function(){
    $(this).parent().toggleClass("active");
    $(this).parent().find(".faq__accordion-text").slideToggle();
  });

  $(".product__media-slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: '30px',
      slidesToShow: 1,
      slidesToScroll: 1
  });
  
  $(".collection-hero__link").click(function(){
    $(this).parent().find(".collection-hero__description").toggleClass("open");
  });

  $("#FacetSortDrawerForm").click(function(){
    $(this).toggleClass("open");
    $(this).find(".select-options").toggle();
  });
  $(".mobile-facets__sort .select").click(function(){
    $(this).toggleClass("open");
    $(this).find(".select-options").toggle();
  });
  $(".facet-filters__sort-select .select-options li").click(function(){
    var v = $(this).data("value");
    $(this).parents("form").find("select[name='sort_by']").val(v).trigger("change");
    $(this).parents("form").submit();
  });

  $(".cart-drawer__note-label").click(function(){
    $(this).parent().toggleClass("open");
  });
  $(".cart-drawer__product-related").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $("a[href*='#']:not([href='#])").click(function() {
    let target = $(this).attr("href");
    $('html,body').stop().animate({
      scrollTop: $(target).offset().top - 100
    }, 1000);
    event.preventDefault();
  });

  if ($('#agegate-popup').length) {
    if(typeof $.cookie('age') === 'undefined' || $.cookie('age') != 'checked'){
      $.magnificPopup.open({
        items: {
          src: '#agegate-popup' 
        },
        type: 'inline',
        closeOnBgClick: false,
        showCloseBtn: false,
        callbacks: {
          open: function() {
            $("#accept_age_gate").click(function(){
              if ($('#agegate-popup #remember').is(':checked')) {
                $.cookie('age', 'checked', { expires: 7 });
              }else{
                $.cookie('age', 'checked', { expires: 1 });
              }
              $.magnificPopup.close();
            });
            $("#refuse_age_gate").click(function(){
              $("#agegate-popup .agegate-info, #agegate-popup .agegate-info-error, #agegate-popup .agegate-remebmer_me, #agegate-popup .agegate-gr-text, #agegate-popup .agegate-link").hide();
              $("#agegate-popup .agegate-logo, #agegate-popup .agegate-info-error").show();
            });
          }
        }
      });
    }
  }
});